<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001207')" prop="name">
              <Input v-model.trim="pageParams.name" :placeholder="$t('key1000781')"/>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1006381')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="registerTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box" v-if="getPermission('ymsPackageInfoImportTemp_insertImportTemp')">
      <!--新建模板-->
      <Button class="mr15" type="primary" @click="$refs['orderImportTemplate'].initOrderImportTemplateData('add')">{{ $t('key1006382') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--模板弹窗-->
    <orderImportTemplateModal ref="orderImportTemplate" @updateData="pageParamsStatus = true"></orderImportTemplateModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";
import orderImportTemplateModal from "@/views/distributor/components/orderManage/orderImportTemplateModal.vue";

export default {
  name: 'orderImportTemplateList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      registerTime: [],
      pageParamsStatus: false,
      pageParams: {
        createdStartTime: null,
        createdEndTime: null,
        name: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002628'),
          key: 'name',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004296'),
          key: 'createdTime',
          minWidth: 170,
          align: 'center',
          render(h, params) {
            let createdTime = params.row.createdTime;
            return h('span', v.$uDate.dealTime(createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 220,
          align: 'left',
          render: (h, params) => {
            let ymsPackageInfoImportTempId = params.row.ymsPackageInfoImportTempId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsPackageInfoImportTemp_updateImportTemp'),
                    clickFn: () => {
                      v.$refs['orderImportTemplate'].initOrderImportTemplateData('edit', ymsPackageInfoImportTempId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsPackageInfoImportTemp_deleteByImportTempId'),
                    clickFn: () => {
                      v.deleteTemplate(ymsPackageInfoImportTempId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsPackageInfoImportTemp_query')) {
        v.tableLoading = true;

        v.axios.post(api.post_ymsPackageInfoImportTemp_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.total = data.total;
              v.tableData = data.list || [];
              v.updateTableDom('tableDom');
            }
          }
          v.tableLoading = false;
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      if (v.$refs['pageParams']) {
        v.$refs['pageParams'].resetFields();
      }
      v.registerTime = [];
      v.resetDate();
      v.getList();
    },
    // 重置时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.registerTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 删除标签
    deleteTemplate(ymsPackageInfoImportTempId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006379'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006380'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000543'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsPackageInfoImportTemp_deleteByImportTempId + ymsPackageInfoImportTempId, null, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    orderImportTemplateModal
  }
};
</script>

<style lang="less">

</style>
